<template>
  <drm-form
    v-if="!fetchingDrm"
    :drm-settings="drmSettings"
    @submit="saveRawKey"
  />
  <loading-page v-else />

</template>

<script>
import DrmForm from './DrmForm.vue'

export default {
  name: 'DrmEdit',
  components: { DrmForm },
  computed: {
    noDrm() { return this.$store.state.drm.noDrm },
    drmSettings() { return this.$store.state.drm.drm },
    fetchingDrm() {
      return this.$store.state.drm.fetchingDrm
    },
  },
  created() {
    this.fetchDrm()
  },
  methods: {
    saveRawKey(obj) {
      if (this.noDrm) {
        this.$store.dispatch('drm/createDrm', obj).then(() => {
          this.$router.push({
            name: 'drm',
            params: {
              toast: {
                message: 'DRM settings saved successfully',
              },
            },
          })
        }).catch(() => {
          this.errorToast('An error occured, couldn\'t save changes')
        })
      } else {
        this.$store.dispatch('drm/updateDrm', obj).then(() => {
          this.$router.push({
            name: 'drm',
            params: {
              toast: {
                message: 'DRM settings saved successfully',
              },
            },
          })
        }).catch(() => {
          this.errorToast('An error occured, couldn\'t save changes')
        })
      }
    },
    fetchDrm() {
      this.$store.dispatch('drm/getDrm').catch(() => {})
    },
  },
}
</script>

<style>

</style>
